import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Existe una alternativa a la ECT para la depresión?",
    answer:
      "Sí. La TMS y SAINT® TMS acelerada son alternativas no invasivas a la ECT. SAINT® está autorizado por la FDA (K220177) para adultos cuya depresión no ha mejorado con antidepresivos. A diferencia de la ECT, no requiere anestesia ni provoca los efectos cognitivos asociados a la ECT.",
  },
  {
    question: "¿SAINT® es una alternativa a la ECT?",
    answer:
      "SAINT® es una alternativa a considerar para adultos con depresión resistente al tratamiento. Es un protocolo de TMS acelerada de cinco días autorizado por la FDA. No requiere anestesia. La idoneidad la determina un psiquiatra tras una evaluación.",
  },
  {
    question: "¿La TMS es tan eficaz como la ECT?",
    answer:
      "La ECT suele ser más eficaz en casos graves o psicóticos, pero conlleva más efectos cognitivos. La TMS y SAINT® tienen perfiles de efectos secundarios más leves y no requieren anestesia. La elección depende del cuadro clínico y la determina un psiquiatra.",
  },
];

export const esAlternativeToEct = makeEsArticle({
  slug: "alternative-to-ect-for-depression",
  title: "Alternativa a la ECT para la depresión | Neuro Wellness",
  description:
    "Alternativas a la terapia electroconvulsiva: TMS y SAINT® TMS acelerada, opciones no invasivas autorizadas por la FDA para la depresión resistente al tratamiento.",
  h1: "Alternativa a la ECT para la depresión",
  breadcrumbLabel: "Alternativa a la ECT",
  shortAnswer:
    "La TMS y SAINT® TMS acelerada son alternativas no invasivas a la ECT para la depresión resistente al tratamiento. SAINT® está autorizado por la FDA (K220177) para adultos cuya depresión no ha mejorado con antidepresivos. A diferencia de la ECT, no requiere anestesia ni provoca los efectos cognitivos asociados a la ECT. La idoneidad la determina un psiquiatra tras una evaluación.",
  keyTakeaways: [
    "La TMS y SAINT® son alternativas no invasivas a la ECT.",
    "SAINT® está autorizado por la FDA (K220177) para adultos.",
    "No requieren anestesia.",
    "No provocan los efectos cognitivos asociados a la ECT.",
    "La idoneidad la determina un psiquiatra.",
  ],
  sections: [
    {
      heading: "Por qué considerar una alternativa a la ECT",
      paragraphs: [
        "La ECT es eficaz para la depresión grave o psicótica, pero requiere anestesia y puede causar efectos cognitivos como pérdida de memoria. Algunos pacientes buscan alternativas con perfiles de efectos secundarios más leves.",
        "La TMS y SAINT® TMS acelerada son tratamientos no invasivos autorizados por la FDA que no requieren anestesia ni provocan efectos cognitivos sistémicos.",
      ],
    },
    {
      heading: "SAINT® TMS acelerada",
      paragraphs: [
        "SAINT® es un protocolo de TMS acelerada: 50 sesiones en cinco días con orientación por fMRI. Está autorizado por la FDA (K220177) para adultos cuya depresión no ha mejorado con antidepresivos. En un ensayo controlado con simulación, el 79 % del grupo activo alcanzó la remisión.",
      ],
    },
    {
      heading: "TMS convencional",
      paragraphs: [
        "La TMS está autorizada por la FDA para adultos con trastorno depresivo mayor que no han mejorado con antidepresivos. Un curso estándar dura unas seis semanas. Es no invasiva y no requiere anestesia.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
